module.exports = __webpack_public_path__ + "static/media/zamygo_partner_siii.1f48395c.png";